export const Globals = {
  ReapitMarketplace: '__REAPIT_MARKETPLACE_GLOBALS__',
}

export const Routes = {
  Home: '/',
  Login: '/login',
  Search: '/search',
  Applicant: '/applicant',
  Vendor: '/vendor',
}
